var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferencesmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66 4.78c0 1.4-1.16 2.54-2.58 2.54A2.56 2.56 0 0 1 1.5 4.78c0-1.4 1.15-2.53 2.58-2.53a2.56 2.56 0 0 1 2.58 2.53Zm8.71-1.1c.62 0 1.13.5 1.13 1.1 0 .62-.5 1.11-1.13 1.11h-4.93c-.63 0-1.13-.5-1.13-1.1 0-.62.5-1.12 1.13-1.12h4.93ZM2.63 11.96h4.93c.63 0 1.13.5 1.13 1.1 0 .62-.5 1.12-1.13 1.12H2.63c-.62 0-1.13-.5-1.13-1.11 0-.61.5-1.11 1.13-1.11Zm11.3 3.61a2.56 2.56 0 0 0 2.57-2.53c0-1.4-1.15-2.54-2.58-2.54a2.56 2.56 0 0 0-2.58 2.54c0 1.4 1.16 2.53 2.58 2.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesmedium);
export default __webpack_public_path__ + "static/media/preferences.medium.b2ca7d735308c78c1cb01fe23670eed7.svg";
export { ForwardRef as ReactComponent };